import React from 'react';
import ContentCard from './ContentCard';
import { withTranslation, Trans } from 'react-i18next';
import { Link } from "react-router-dom";

function AfterResetPasswordComponent(props) {

    return (
        <ContentCard title={<Trans i18nKey="user_signout" />}>
            <div className="mt-5">
                <div className="mb-2">
                    <p>
                        <Trans i18nKey="user_signout_instructions" />
                    </p>
                </div>
                <div className="mt-4 d-grid gap-2 col-9 mx-auto">
                    <Link to="/">
                        <button className="btn btn-primary btn-lg w-100 mt-2"><Trans i18nKey="user_signout_button" /></button>
                    </Link>
                </div>
            </div>
        </ContentCard>
    );
}

export default withTranslation()(AfterResetPasswordComponent);
